import { z } from "zod"

import { OrderFiltersSchema } from "@optimist/schemas"

const ActiveOrderListFiltersSchema = OrderFiltersSchema.pick({
	search: true,
	status: true,
	journeyDefinitionId: true,
})

export type ActiveOrderListFilters = z.infer<typeof ActiveOrderListFiltersSchema>

export const OrderListSearchSchema = ActiveOrderListFiltersSchema.extend({
	sortBy: OrderFiltersSchema.shape.sortBy,
	sortDirection: OrderFiltersSchema.shape.sortDirection,
	page: OrderFiltersSchema.shape.page,
	limit: OrderFiltersSchema.shape.limit,
})

export function parseOrderListFilterFormData(formData: FormData): ActiveOrderListFilters {
	const search = readOptionalFormValue(formData, "search")
	const status = readOptionalFormValue(formData, "status")
	const journeyDefinitionId = readOptionalFormValue(formData, "journeyDefinitionId")

	return ActiveOrderListFiltersSchema.parse({
		...(search === undefined ? {} : { search }),
		...(status === undefined || status === "all" ? {} : { status }),
		...(journeyDefinitionId === undefined || journeyDefinitionId === "all"
			? {}
			: { journeyDefinitionId }),
	})
}

function readOptionalFormValue(formData: FormData, name: string): string | undefined {
	const value = formData.get(name)
	if (value === null) return undefined
	if (typeof value !== "string") {
		throw new Error(`Order filter ${name} must be a string`)
	}
	const trimmed = value.trim()
	return trimmed.length === 0 ? undefined : trimmed
}
